<template>
    <table class="table sort">
        <tfoot>
            <tr v-if="newFields.length">
                <td class="col-xs-4 oc-settings__add-row" colspan="2">
                    <select class="oc-settings-select" v-model="field" style="width: 100%">
	                    <option :value="{}">Выберите поле</option>
                        <option v-if="!existField(field)" v-for="(field, index) in newFields" :key="index" :value="field">{{ field.title }}</option>
                    </select>
                </td>
                <td colspan="3" class="oc-settings__field-value-col oc-settings__add-row">
                   <button class="oc-settings-btn" @click.stop.prevent="addItem">Добавить поле</button>
                </td>
            </tr>
        </tfoot>
        <tbody v-sortable="getSortParams()">
            <tr v-for="(item, index) in settings.form_fields" :key="index">
                <td class="oc-col_min-width">
                    <i class="icon16 sort sort-handle" style="cursor: move;"></i>
                </td>
                <td class="oc-settings__field-name-col">
	                {{ item.title }}
                </td>
                <td class="oc-settings__field-value-col">
                    <input type="text" class="input" v-if="item.type == 'text_html' || item.type == 'checkbox'" v-model="settings.form_fields[index].text" placeholder="">
                    <input type="text" class="input" v-if="item.type == 'tel'" v-model="settings.form_fields[index].mask" placeholder="+7(###)###-##-##">
                    <a href="#/ordercall" class="oc-inline-link oc-form__topic_add" v-else-if="item.type == 'topic'" @click="$emit('openTopic')">Добавить тему</a>
                    <div v-else-if="item.type == 'time'">
                        <input class="oc-settings-time-input" type="time" v-model="settings.form_fields[index].before">
                        <input class="oc-settings-time-input" type="time" v-model="settings.form_fields[index].after">
                    </div>
                </td>
                <td class="oc-settings__field-value-col">
                  <label v-if="isLabelVisible(item.type)" class="oc-settings__field-label">
                    <checkbox class="valign-bottom" :checked="!!(settings.form_fields[index].required)" @change="val => { settings.form_fields[index].required = +val }"/>
                    Обязательное
                  </label>
                  <label v-if="isCheckboxSelected(item.type)" class="oc-settings__field-label">
                    <checkbox class="valign-bottom" :checked="!!(+settings.form_fields[index].is_checked)" @change="val => { settings.form_fields[index].is_checked = val }"/>
                    Сразу выбрано
                  </label>
                </td>
	            <td class="oc-col_min-width">
                    <span class="oc-clickable" @click="deleteItem(index)">
                        <i class="oc-icon16 ico-delete"></i>
                    </span>
	            </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import Vue from 'vue';
import VueSortable from "../../../components/sortable"
import Checkbox from '../../../components/Checkbox.vue'

let email = { title: 'E-mail', type: 'email', required: 1, is_unique: 1 };
let tel = { title: 'Телефон', type: 'tel', mask: '', required: 1, is_unique: 1 };
let comment = { title: 'Комментарий', type: 'comment', required: 1, is_unique: 1 };
let text_name = { title: 'Имя', type: 'text_name', required: 1, is_unique: 1 };
let time = { title: 'Время для звонка', type: 'time', before: '08:00', after: '16:00', is_unique: 1 };
let topic = { title: 'Тема обращения', type: 'topic', required: 1, is_unique: 1 };
let checkbox = { title: 'Checkbox', type: 'checkbox', text: '', required: 1, is_unique: 0, is_checked: 0, unique_id: '' };
let text_html = { title: 'Произвольный текст', type: 'text_html', text: '', is_unique: 0 };
let captcha = { title: 'Captcha', type: 'captcha', is_unique: 1 };

export default Vue.extend({
    props: ['settings'],
    components: {
        Checkbox
    },
	data() {
        let field = {}
		return {
			field: field,
            fields: [
                tel,
                comment,
                email,
                topic,
                text_name,
                time,
                checkbox,
                text_html,
                captcha
            ]
		}
    },
    computed: {
        newFields() {
            let fields = []
            for(let field of this.fields) {
                if (!this.existField(field)) {
                    fields.push(Object.assign({}, field))
                }
            }

            return fields
        }
    },
	methods: {
        addItem() {
            if (this.field == undefined) {
                return
            }
            if(Object.keys(this.field).length) {
                if (this.field.type === 'checkbox') {
                  this.field.unique_id = this.generateUniqueId();
                }

                this.settings.form_fields.push(this.field);
                this.field = {};
            }
        },
        generateUniqueId() {
          return 'xxxx-xxxx-4xxx-yxxx-xxxx-xxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
          });
        },
        deleteItem: function (index) {
            this.settings.form_fields.splice(index, 1);
        },
        existField(field) {
            if (!this.settings.form_fields) {
                return false
            }
            let exist = false
            for (let item of this.settings.form_fields) {
                if (field.type == item.type && !!+item.is_unique) {
                    exist = true
                }
            }

            return exist
        },
        getSortParams() {
            let self = this
            let params = {
                animation: 150,
                handle: '.sort-handle',
                onEnd(event) {
                    self.sortUpdate(event)
                }
            }
            return params
        },
        sortUpdate(event) {
            let clonedItems = this.settings.form_fields.filter((item) => {
                return item;
            });
            clonedItems.splice(event.newIndex, 0, clonedItems.splice(event.oldIndex, 1)[0]);
            this.settings.form_fields = [];
            this.$nextTick(() => {
                this.settings.form_fields = clonedItems;
            });
        },
        isLabelVisible(type) {
          return type !== 'text_html' && type !== 'captcha' && type !== 'time';
        },
        isCheckboxSelected(type) {
          return this.isLabelVisible(type) && type === 'checkbox';
        },

	},
    directives: {
        sortable: VueSortable
    }
});
</script>

<style>
.oc-form__topic_add {
    font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/webpack/vue/settings/components/form/FormCreator.vue